import { CenterItem } from '@components/LinearLayout';
import { styled } from 'styled-components';

export const PartnerItemRoot = styled(CenterItem)<{
  $lightMode?: boolean;
  $partnerMode?: boolean;
  $noBorder?: boolean;
  $borderRadius?: string;
  $width?: string;
  $height?: string;
}>`
  overflow: hidden;
  position: relative;
  background-color: ${({ theme }) => theme.color.white};
  border-radius: ${({ $borderRadius, theme }) =>
    $borderRadius || theme.borderRadius.radius10};

  width: ${({ $lightMode, $partnerMode }) =>
    $partnerMode
      ? `min(23.3rem, 100%)`
      : $lightMode
        ? `min(25.5rem, 100%)`
        : `min(27.3rem, 100%)`};
  height: ${({ $partnerMode }) => ($partnerMode ? `12.5rem` : '13.6rem')};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: min(15.6rem, 100%);
    width: ${({ $width }) => $width};
    height: fit-content;
    margin: auto;
    height: ${({ $height }) => $height};
  }

  &:hover {
    cursor: pointer;
  }
`;
export const BackgroundImageOverlay = styled.div<{ $isHovered: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: inherit;
  pointer-events: none;

  ${({ $isHovered, theme }) =>
    $isHovered
      ? `
        opacity: 0.5;
        mix-blend-mode: multiply;
        background: ${theme.color.mobilityGrey3};
        border: 0.4rem solid ${theme.color.mobilityGrey3};
        transition: all 0.1s linear;
      `
      : `
        background: transparent;
        border: 0.4rem solid ${theme.color.lightStrokeGrey};
        transition: all 0.1s linear;
      `}
`;

export const LogoWrapper = styled.div<{ $lightMode?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 1rem;

  background-color: ${({ $lightMode, theme }) =>
    $lightMode ? theme.color.white : 'white'};
`;

export const LogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
